import './styles.scss';
import React, {useContext, useEffect, useState} from "react";

/* Type, Constants, Utils */
import Utils from "../../../../utils";
import * as Constants from "../../../../constants";
import {IUserState} from "../../../../types/redux/user";

/* Bootstrap */
import {Dropdown} from "react-bootstrap";

/* Redux */
import {useSelector} from "react-redux";
import {RootState} from "../../../../redux";

/* Components */
import DownloadModal from "../../../modal/download-modal";
import LoginPromptModal from "../../../modal/login-prompt-modal";

/* Hooks */
import useDownloadFile from "./useDownloadFile";
import useSearchResults from "../../../../hooks/useSearchResults";
import {IRecordsContext, RecordsContext} from "../../../../types/document";

export interface IDownload {
  filename: string,
  percentage: number
}

interface IProp {
  context: string;
}

const ALLOWED_MEDIA: string[] = ['text','image','pdf','zip'];

const DownloadDropdown = (props: IProp):JSX.Element => {
  const {
    context
  } = props;

  /* redux */
  const userState: IUserState = useSelector<RootState, IUserState>(state => state.user);

  /* state */
  const [pendingLogin, setPendingLogin] = useState<boolean>(false);
  const [loginPromptModal, setLoginPromptModal] = useState<boolean>(false);

  /* hooks */
  const {downloadFile, downloads} = useDownloadFile();

  /* local */
  const record: any = useContext<IRecordsContext>(RecordsContext).records[0];
  const multipleRecords = useSearchResults().selectedRecords();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const selectedRecords = (context === Constants.CARD) ? [record] : multipleRecords;

  const artifacts: any = selectedRecords[0]?.artifact ? JSON.parse(selectedRecords[0].artifact) :  null ;
  let allFilesTotalBytes: number = 0;

  useEffect(()=>{
    if (pendingLogin && userState.loggedIn) {
      setPendingLogin(false);
      downloadFile(selectedRecords[0].id, `${selectedRecords[0].id}.zip`, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userState.loggedIn])

  const downloadMenuItem = (key: string, name: string, size: string):JSX.Element => {
    return (
      <Dropdown.Item
        key={key}
        onClick={() => {
          if (name === Constants.ALL_FILES_ZIP) {
            if (userState.loggedIn) {
              downloadFile(selectedRecords[0].id, `${selectedRecords[0].id}.zip`, true)
            } else {
              setPendingLogin(true);
              setLoginPromptModal(true);
            }
          } else {
            downloadFile(selectedRecords[0].id, name, false)
          }
        }}
      >
        <i className={'bi bi-download fst-normal me-1 bg-transparent'}/>
        <span>{name} - {Utils.convertBytes(size)}</span>
      </Dropdown.Item>
    )
  }

  return (
    <>
      <Dropdown className={'download-dropdown'}>
      <Dropdown.Toggle
        disabled={!selectedRecords[0] || !artifacts}
        variant={"success"}
        id={"dropdown-download"}
        className={"btn btn-sm btn-light mt-0"}
      >
        <i className={'bi bi-download'}/>
        <span className={'ms-2 me-1 text-smaller'}>Download</span>
      </Dropdown.Toggle>

      {artifacts && <Dropdown.Menu>
        {artifacts.map((artifact:any, index:number) => {
          /* disallow video and audio files from downloads */
          const mediaType: string[] = artifact.mediaType.split('/');
          if (ALLOWED_MEDIA.indexOf(mediaType[0]) || ALLOWED_MEDIA.indexOf(mediaType[1])) {
            allFilesTotalBytes += artifact.size;
            return downloadMenuItem(`dlmi${index}`, artifact.name, artifact.size)
          }
          return <></>
        })}

        {downloadMenuItem(`dlmi${artifacts.length+1}`,
          Constants.ALL_FILES_ZIP,
          String(allFilesTotalBytes)
        )}
      </Dropdown.Menu>}
    </Dropdown>

      <DownloadModal
        downloads={downloads}
        show={downloads.length > 0}
      />

      {loginPromptModal && <LoginPromptModal
        title={'Download All Files'}
        show={loginPromptModal}
        onHide={()=>setLoginPromptModal(false)}/>}
    </>
  )
}

export default DownloadDropdown;
